import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  eventContainer: {
    cursor: "pointer",
    borderRadius: "5px",
    border: `1px solid ${theme.palette.gray.light}`,
    "&:hover": {
      border: `1px solid ${theme.palette.border.primary}`,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      width: "600px",
    },
    "& .MuiDialogContentText-root": {
      marginLeft: "0!important",
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "16px",
    },
    "& .MuiDialogContent-root": {
      paddingTop: "20px !important",
      overflow: "hidden",
      paddingBottom: "10px !important",
    },
  },
  eventLogo: {
    width: 100,
    height: 70,
    borderRadius: 5,
    marginRight: theme.spacing(1),
  },
  eventInfo: {
    maxWidth: 350,
    width: "fit-content",
    wordBreak: "break-all",
  },
  enterButton: {
    textDecoration: "none",
    width: "80px",
    fontWeight: 400,
    color: theme.palette.button.default,
    whiteSpace: "nowrap",
    "&:hover": {
      textDecoration: "none",
      color: theme.palette.button.primaryHover,
    },
  },
  eventInfoContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  arrowIcon: {
    fontSize: "0.75rem",
    marginLeft: "5px",
  },
}));
